// project import
// types
import { NavItemType } from '~/types/menu';

import menu from './dashboard';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [menu],
};

export default menuItems;
